import React from 'react';
import { motion } from 'framer-motion';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Backdrop = ({ mobileNavigationHandler }: { mobileNavigationHandler: React.Dispatch<React.SetStateAction<any>> }) => {
  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 0.5 },
    exit: { opacity: 0 },
  };

  return <motion.div className='fixed inset-0 bg-black bg-opacity-50 z-30' initial='hidden' animate='visible' exit='exit' variants={backdropVariants} transition={{ duration: 0.5 }} onClick={mobileNavigationHandler} />;
};
